import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function TClascli() {
    const [tipos, setTipos] = useState([]);
    const [tiposFiltrados, setTiposFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idClacli: '',
        nomClacli: ''
    });
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_URL = '/api/tiposcliente';

    useEffect(() => {
        cargarTipos();
    }, []);

    useEffect(() => {
        filtrarTipos();
    }, [busqueda, tipos]);

    const cargarTipos = async () => {
        try {
            const response = await axios.get(API_URL);
            setTipos(response.data);
            setTiposFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar tipos de cliente:', error);
            alert('Error al cargar los tipos de cliente');
        }
    };

    const filtrarTipos = () => {
        if (!busqueda) {
            setTiposFiltrados(tipos);
            setPaginaActual(1);
            return;
        }

        const filtrados = tipos.filter(tipo =>
            tipo.idClacli?.toString().includes(busqueda) ||
            tipo.nomClacli?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setTiposFiltrados(filtrados);
        setPaginaActual(1);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idClacli: '',
            nomClacli: ''
        });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (tipo) => {
        setFormulario({
            idClacli: tipo.idClacli,
            nomClacli: tipo.nomClacli
        });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idClacli: '',
            nomClacli: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.nomClacli.trim()) {
            alert('El nombre del tipo de cliente es requerido');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idClacli}`, formulario);
                alert('Tipo de cliente actualizado exitosamente');
            } else {
                await axios.post(API_URL, formulario);
                alert('Tipo de cliente creado exitosamente');
            }
            cargarTipos();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el tipo de cliente');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este tipo de cliente?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('Tipo de cliente eliminado exitosamente');
                cargarTipos();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el tipo de cliente');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = tiposFiltrados.map(tipo => ({
            'ID': tipo.idClacli,
            'Nombre': tipo.nomClacli
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Tipos de Cliente');
        XLSX.writeFile(workbook, 'tipos_cliente.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const tiposActuales = tiposFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(tiposFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Tipos de Cliente</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Tipo
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre del Tipo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tiposActuales.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="sin-datos">No hay tipos de cliente para mostrar</td>
                            </tr>
                        ) : (
                            tiposActuales.map(tipo => (
                                <tr key={tipo.idClacli}>
                                    <td>{tipo.idClacli}</td>
                                    <td>{tipo.nomClacli}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(tipo)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(tipo.idClacli)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, tiposFiltrados.length)} de {tiposFiltrados.length} registros
                    </span>
                    <select
                        value={itemsPorPagina}
                        onChange={cambiarItemsPorPagina}
                        className="select-registros"
                    >
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button
                        onClick={() => cambiarPagina(1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                        title="Primera página"
                    >
                        ⏮️
                    </button>
                    <button
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                    >
                        ◀️
                    </button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (
                            numeroPagina === 1 ||
                            numeroPagina === totalPaginas ||
                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                        ) {
                            return (
                                <button
                                    key={numeroPagina}
                                    onClick={() => cambiarPagina(numeroPagina)}
                                    className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}
                                >
                                    {numeroPagina}
                                </button>
                            );
                        } else if (
                            numeroPagina === paginaActual - 2 ||
                            numeroPagina === paginaActual + 2
                        ) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                    >
                        ▶️
                    </button>
                    <button
                        onClick={() => cambiarPagina(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                        title="Última página"
                    >
                        ⏭️
                    </button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Tipo de Cliente' : 'Nuevo Tipo de Cliente'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Nombre del Tipo *</label>
                                <input
                                    type="text"
                                    value={formulario.nomClacli}
                                    onChange={(e) => setFormulario({ ...formulario, nomClacli: e.target.value })}
                                    required
                                    maxLength={15}
                                    placeholder="Ingrese el nombre del tipo de cliente"
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TClascli;
